import * as angular from "angular";
import { BENG_LOGS_SERVICE, BEngLogsService } from "./beng-logs.service";
import { BENGLOG_DIALOG_SERVICE, BengLogDialogService } from "./beng-log-config-dialog.controller";
import { BENGLOG_PASSWORD_DIALOG_SERVICE, BengLogPasswordDialogService } from "./beng-log-password-dialog.controller";
import { configRoute } from "./beng-logs.router";

export default angular
    .module("board.web.admin.bengLogs", [])
    .service(BENG_LOGS_SERVICE, BEngLogsService)
    .service(BENGLOG_DIALOG_SERVICE, BengLogDialogService)
    .service(BENGLOG_PASSWORD_DIALOG_SERVICE, BengLogPasswordDialogService)
    .config(configRoute)
    .name;



// WEBPACK FOOTER //
// ./app/beng-logs/beng-logs.module.ts